import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function ChildrenView() {
  useDocumentTitle('Children and young people-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb image={'bg-image-23'} title={'Children and Young People'} />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                Supporting children and young people at home
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">W</span>e acknowledge the
                  individuality of each child and family and work to ensure the
                  best possible outcomes for each child in our care.
                </p>
                <p className="values_p3">
                  A greater number of children with terminal illnesses or
                  complex healthcare requirements are now living into adulthood
                  thanks to advancements in medicine and technology.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/learning-disability">
                        Learning Disability
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/how-we-deliver">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/testimonials">
                        Testimonials
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">The way we support you</h2>
                <p className="white-color">
                  Our program seeks to improve children's and adolescents' lives
                  and can follow them as they enter adulthood.
                </p>
                <p className="white-color">
                  We provide assistance for children of all ages, from infants
                  to teenagers, who need complex care at home. The spectrum of
                  diseases encompasses spinal and brain injuries, epilepsy,
                  autism, chromosomal and genetic conditions, chronic lung
                  disease, complicated metabolic disease, and cerebral palsy
                  with substantial disability. We can assist with:
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>Long-term invasive and non-invasive ventilation.</li>
                    <li>
                      Tracheostomy management (including weaning to
                      de-cannulation).
                    </li>
                    <li>Severe/complex epilepsy.</li>
                    <li>
                      Disorders of consciousness (e.g. minimally conscious).
                    </li>
                    <li>Enteral feeding (e.g. gastrostomy, jejunostomy).</li>
                    <li>Parenteral nutrition/TPN via a central line.</li>
                    <li>Dysphagia.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">
                  Caring for children and young people
                </h2>
                <p>
                  Our family-centered services involve close collaboration with
                  you and your child to deliver specialized clinical and
                  individualized care. Recognizing the individuality of each
                  child, we will develop a customized care and support plan that
                  outlines their unique objectives and is geared toward helping
                  them make the most of their lives. Our care is designed to
                  promote independence and social interaction inside and outside
                  the house.
                </p>
                <p>
                  Our service is nurse-led, and the care staff and
                  multidisciplinary teams collaborate with our qualified
                  registered pediatric nurses. Our registered nurses closely
                  watch and oversee the service with regard to clinical matters.
                  This guarantees that clinical duties and interventions can be
                  safely carried out in your home by our trained healthcare
                  assistants.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Discharging from hospital</h2>
                <p className="white-color">
                  To safely send your child home after hospitalization, we
                  collaborate closely with a number of Long Term Ventilation
                  Teams and Acute settings. We would present qualified medical
                  personnel who visit your child in the hospital as part of the
                  discharge plan. Prior to the predetermined date of release,
                  they would be trained and shadowed. To help children return to
                  their homes as soon and securely as possible, we collaborate
                  with families, professionals, and teams from our community.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">
                  Supporting in educational settings
                </h2>
                <p className="">
                  Our well-trained care teams can assist your child in attending
                  school. This guarantees continuity of care in every situation.
                </p>
                <p>
                  Our staff are trained to assist students in both specialized
                  and general educational setting
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Transition from childhood to adulthood
                </h2>
                <p className="white-color">
                  It can be difficult to move from a children's program to an
                  adult one. To make this transition as easy as possible our
                  team will facilitate communication between the healthcare
                  services for children and adults.
                </p>
                <p className="white-color">
                  Planning is essential, and we would assume responsibility for
                  communicating with the commissioner to ensure that a new
                  assessment is finished and money is decided before the
                  transition.
                </p>
                <p className="white-color">
                  We have a stable team in place that can adjust to changes in
                  your child's care plan. We'll make sure to keep you informed
                  of the status of the transfer process
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default ChildrenView;
